import * as React from 'react';
import styled from 'styled-components';
import { pulseAnimation } from './common';
import { TSizes } from '../JRCTypography/JRCTypography.d';
import { SIZES, lineHeightRatio } from '../JRCTypography/JRCTypography.styles';

const SkeletonLineContainer = styled.div<{ width?: string; padding?: string }>`
    width: ${(props) => props.width || `60%`};
    padding: ${(props) => props.padding};
`;
type SkeletonLineProps = {
    height?: string;
    borderRadius: string;
    margin: string;
};
const SkeletonLine = styled.div<SkeletonLineProps>`
    height: ${(props) => props.height || props.theme.font.lineHeight};
    border-radius: ${(props) => props.borderRadius};
    margin: ${(props) => props.margin};
    ${pulseAnimation}
`;

export type JRCSkeletonLineProps = {
    width?: string;
    size?: TSizes;
    lineHeight?: number;
    height?: string;
    borderRadius?: string;
    margin?: string;
};
export const JRCSkeletonLine = ({
    width,
    size = 'm',
    lineHeight,
    height,
    borderRadius = '4px',
    margin = '0',
}: JRCSkeletonLineProps) => {
    const params: SkeletonLineProps = {
        height: height,
        borderRadius: borderRadius,
        margin: margin,
    };
    let padding;
    if (size) {
        const fontSize = SIZES[size];
        if (!lineHeight) {
            lineHeight = fontSize * lineHeightRatio;
        }
        params.height = fontSize.toString() + 'px';
        padding = (Math.round(((lineHeight - fontSize) / 2) * 100) / 100).toString() + 'px 0px';
    }
    return (
        <SkeletonLineContainer width={width} padding={padding}>
            <SkeletonLine {...params} />
        </SkeletonLineContainer>
    );
};
